// extracted by mini-css-extract-plugin
export default {"statusDisplay":"StatusDisplay_statusDisplay__yiDQk","statusBadge":"StatusDisplay_statusBadge__1J65t"};